var path = '/client/common/modules/fab/views/fab-trigger.html';
var html = "<div class=\"fab__primary\" ng-transclude></div>\n";
window.angular.module('AppTemplates').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;